import { Outlet } from "react-router-dom";
import { RoleProtectedRoute } from "@/components/RoleProtectedRoute";

const AdminLayout = () => (
  <RoleProtectedRoute allowedRoles={["ROLE_ADMIN"]}>
    <Outlet />
  </RoleProtectedRoute>
);

export default AdminLayout;
